import React from 'react';
import * as Sentry from '@sentry/react';

function ErrorBoundaryFallback({ error, resetError, eventId }) {
  const handleReport = () => {
    if (eventId) {
      Sentry.showReportDialog({ eventId });
    } else {
      Sentry.showReportDialog();
    }
  };

  const handleReload = () => {
    if (resetError) {
      resetError();
    }
    window.location.reload();
  };

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light p-4 text-center">
      <div className="card shadow-sm border-0 p-4" style={{ maxWidth: '520px', width: '100%', borderRadius: '12px' }}>
        <div className="mb-3">
          <i className="mdi mdi-alert-circle-outline text-danger" style={{ fontSize: '4rem' }}></i>
        </div>
        <h4 className="text-dark fw-bold mb-2">Algo salió mal</h4>
        <p className="text-muted mb-4 fs-6">
          Ha ocurrido un error inesperado al procesar la vista. Nuestro equipo técnico ha sido notificado automáticamente para resolverlo.
        </p>
        <div className="d-flex justify-content-center gap-3">
          <button
            type="button"
            className="btn btn-primary px-4 py-2"
            onClick={handleReload}
          >
            <i className="mdi mdi-refresh me-1"></i> Recargar página
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary px-4 py-2"
            onClick={handleReport}
          >
            <i className="mdi mdi-message-alert-outline me-1"></i> Reportar problema
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorBoundaryFallback;
